import { render, staticRenderFns } from "./CreateSoftwareOptionModal.vue?vue&type=template&id=06385f2b&scoped=true&"
import script from "./CreateSoftwareOptionModal.vue?vue&type=script&lang=js&"
export * from "./CreateSoftwareOptionModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateSoftwareOptionModal.vue?vue&type=style&index=0&id=06385f2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06385f2b",
  null
  
)

export default component.exports